import * as React from 'react';

import {roundedElements} from 'Services/BaseHelpers';

/**
 * @function Modal
 * @param {object} props
 * @param className
 * @return {JSX.Element}
 * @constructor
 */
const Modal = (props) => {
    return (
        <div className={`
            modal-container w-full
            ${props.size ?? 'max-w-screen-sm'}
            mx-auto max-h-full
            shadow-lg z-50 overflow-y-auto rounded-xl
            ${roundedElements() ? 'rounded' : ''}
            ${props.className ?? 'bg-white'}
        `}>
            {props.children}
        </div>
    );
};

export default Modal;
